<template>
  <div>
    <select-tag :showTagDialog="showTagDialog" @addTag="addTag" @close="showTagDialog = false"></select-tag>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'客戶列表'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>客戶名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-datepicker v-model="data.birthday">
              <label>生日</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>性別</label>
              <md-select v-model="data.gender">
                <md-option :value="'all'">全部</md-option>
                <md-option :value="'m'">男</md-option>
                <md-option :value="'f'">女</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>年齡(起始)</label>
              <md-input type="number" v-model="data.age_from"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>年齡(結束)</label>
              <md-input type="number" v-model="data.age_until"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-datepicker v-model="data.created_at_from">
              <label>基本資料建立日期(開始)</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item">
            <md-datepicker v-model="data.created_at_until">
              <label>基本資料建立日期(結束)</label>
            </md-datepicker>
          </div>
        </div>
        <div class="md-layout md-gutter" v-if="tag.length > 0">
          <div class="md-layout-item">
            <md-table>
              <md-table-row>
                <md-table-head>標籤名稱</md-table-head>
                <md-table-head></md-table-head>
              </md-table-row>
              <md-table-row v-for="(_tag, index) in tag" :key="tag.id">
                <md-table-cell>
                  <a v-bind:style="{backgroundColor: `#${_tag.color}`}">
                  {{_tag.name}}
                  </a>
                </md-table-cell>
                <md-table-cell>
                  <a @click="tag.splice(index, 1)">
                    移除標籤
                  </a>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
          <md-button class="md-raised md-primary" @click="showTagDialog = true">新增標籤搜尋</md-button>
          <md-button 
            class="md-raised md-primary" 
            @click="$router.push('/patient/add')"
            v-if="hasScope('PATIENT_UPSERT')"
          >新增客戶</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getPatients()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head><span :class="{'sort-desc': sortKey === 'id_alt' && sortDesc, 'sort-asc': sortKey === 'id_alt' && !sortDesc}" @click="setSort('id_alt')">客戶編號</span></md-table-head>
              <md-table-head><span :class="{'sort-desc': sortKey === 'name' && sortDesc, 'sort-asc': sortKey === 'name' && !sortDesc}" @click="setSort('name')">姓名</span></md-table-head>
              <md-table-head><span :class="{'sort-desc': sortKey === 'gender' && sortDesc, 'sort-asc': sortKey === 'gender' && !sortDesc}" @click="setSort('gender')">性別</span></md-table-head>
              <md-table-head><span :class="{'sort-desc': sortKey === 'birthday' && sortDesc, 'sort-asc': sortKey === 'birthday' && !sortDesc}" @click="setSort('birthday')">年齡</span></md-table-head>
              <md-table-head>最近看診</md-table-head>
              <md-table-head>標籤</md-table-head>
            </md-table-row>
            <md-table-row v-for="(patient, index) in patients" :patients="patient" :key="patient.id">
              <md-table-cell>{{patient.id_alt}}</md-table-cell>
              <md-table-cell>
                <router-link :to="`/patient/${patient.id}`" v-if="hasScope(['PATIENT_UPSERT', 'PATIENT_VIEW'])">
                  {{patient.name}}
                </router-link>
                <div v-else>
                  {{patient.name}}
                </div>

              </md-table-cell>
              <md-table-cell>{{genderCharConvert(patient.gender)}}</md-table-cell>
              <md-table-cell>{{ageConvert(patient.birthday)}}</md-table-cell>
              <md-table-cell>{{getLastRecord(patient.record)}}</md-table-cell>
              <md-table-cell>
                <div v-if="patient && patient.tag.length > 0">
                  <a v-for="tag in patient.tag" v-bind:style="{backgroundColor: `#${tag.tag_group.color}`}">
                    {{tag.name}}
                  </a>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter md-alignment-center-center paginate-container">
        <div class="md-layout-item md-size-100">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getPatients"
            :prev-text="'前頁'"
            :next-text="'下頁'"
             :container-class="'pagination'"
             :no-li-surround="true"
            >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import SelectTag from '@/components/Patient/SelectTag'
import Paginate from 'vuejs-paginate'
import axios from 'axios'
import moment from 'moment'
import urls from '@/urls'
import { hasScope } from '@/services/auth'

export default {
  data () {
    return {
      showTagDialog: false,
      data: {
        id_alt: null,
        birthday: null,
        name: null,
        gender: null,
        age_from: null,
        age_until: null,
        created_at_from: null,
        created_at_until: null
      },
      pageCount: 0,
      page: 1,
      sortKey: null,
      sortDesc: false,
      tag: [],
      patients: []
    }
  },
  components: {
    PageTitle, SelectTag, Paginate
  },
  created () {
    this.getPatients()
  },
  methods: {
    hasScope,
    getLastRecord: function (records) {
      let record = records[0]
      if (!record) {
        return
      }
      return moment(record.created_at).format('YYYY-MM-DD')
    },
    setSort: async function (key) {
      this.sortKey = key
      this.sortDesc = !this.sortDesc
      this.getPatients(this.page)
    },
    clearAll: async function () {
      this.patients = []
      this.tag = []
      for (var i in this.data) {
        this.data[i] = null
      }
    },
    addTag: function (tag) {
      if (!Array.isArray(this.tag)) {
        this.tag = []
      }
      this.tag.push(tag)
    },
    getPatients: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      this.page = page
      let req = await axios.get(urls({route: 'patient'}), {
        params: {
          page,
          sort: this.sortKey,
          order: this.sortDesc ? 'desc' : 'asc',
          ...this.data,
          gender: this.data.gender === 'all' ? null : this.data.gender,
          birthday: this.data.birthday ? moment(this.data.birthday).format('YYYY-MM-DD') : null,
          tag: this.tag.length > 0 ? this.tag.map(i => i.id).join(',') : undefined
        }
      })
      this.patients = req.data.data
      this.pageCount = req.data.count
    },
    genderCharConvert (character) {
      switch (character) {
        case 'm':
          return '男'
        case 'f':
          return '女'
      }
    },
    ageConvert (date) {
      return moment().diff(date, 'years')
    }
  }
}
</script>

<style>
.sort-desc::after {
  content: " ▼";
}
.sort-asc::after {
  content: " ▲";
}
</style>



// WEBPACK FOOTER //
// src/components/Patient/PatientList.vue